import { IProgressCard, IRatingCard, IViewCard, } from "../../interfaces/DashboardOverview";
import { useEffect, useState } from "react";
import { IconType } from "react-icons";
import { FiAward, FiBook, FiServer, FiUsers } from "react-icons/fi";
import ProgressCard from "../../components/shared/ProgressCard";
import ViewCard from "../../components/shared/ViewCard";
import { Box } from "@radix-ui/themes";
import launchingsoon from "../../assets/images/launchingsoon.png";
import launchingsoonMobile from "../../assets/images/launchingsoonMobile.png";
import DashboardService from "../../services/DashboardService";
import StarRating from "../../components/shared/StarRating";
import Skeleton from "../../components/shared/Skeleton";

interface IconMap {
  [key: string]: IconType;
}

const icons: IconMap = {
  FiBook: FiBook,
  FiServer: FiServer,
  FiUsers: FiUsers,
  FiAward: FiAward,
};

function OverviewWidget() {
  const dashboardService = new DashboardService();

  const [viewData, setViewData] = useState<IViewCard[]>([]);
  //   const [progressData, setProgressData] = useState<IProgressCard[]>([]);
  //   const [ratingData, setRatingData] = useState<IRatingCard[]>([]);

  const [isLoading, setLoading] = useState<boolean>(false);
  const primaryColor = "#5F488A";

  const gradientStyle: React.CSSProperties = {
    background: `
    linear-gradient(90deg, rgba(0, 0, 0, 0.40) 0%, rgba(194, 194, 194, 0.40) 100%),
    ${primaryColor}
  `,
  };
  useEffect(() => {
    setLoading(true);
    dashboardService
      .getDashboardData()
      .then(({ viewCard }) => {
        setViewData(viewCard);
        setLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
      });
  }, []);

  //   const renderViewCards = () => {
  //     return (
  //       <div className="grid grid-cols-2 grid-rows-2 gap-2">
  //         {viewData.map((el, index) => (
  //           <div
  //             key={index}
  //             className="flex bg-transparent p-2 justify-center items-center"
  //           >
  //             <ViewCard Icon={icons[el.icon]} title={el.title} value={el.value} />
  //           </div>
  //         ))}
  //       </div>
  //     );
  //   };

  //   const renderProgressCards = () => {
  //     return (
  //       <div className="flex space-x-2">
  //         {progressData.map((el, index) => (
  //           <ProgressCard
  //             key={index}
  //             title={el.title}
  //             value={el.value}
  //             incrementValue={el.incrementValue}
  //           />
  //         ))}
  //       </div>
  //     );
  //   };

  //   const renderRatingCards = () => {
  //     return (
  //       <div className="flex space-x-2">
  //         {ratingData.map((el, index) => (
  //           <div
  //             key={index}
  //             className="h-28 w-40 bg-black opacity-60 rounded-lg flex flex-col justify-center space-y-4 p-4 text-white"
  //           >
  //             <span className="text-[12px] font-bold">{el.title}</span>
  //             <StarRating key={index} outOf={el.outOf} rating={el.rating} disabled />
  //           </div>
  //         ))}
  //       </div>
  //     );
  //   };

  //   // if (isLoading)
  //   //   return (
  //   //     <Box className="w-full min-w-fit max-w-fit">
  //   //       {/* <span className="text-app-gray-medium font-semibold block">Overview</span> */}
  //   //       <Skeleton width={400} height={200}></Skeleton>
  //   //     </Box>
  //   //   );
  if (isLoading) {
    return (
      <div className="w-full h-24 rounded-[20px] bg-gray-200 animate-pulse" />
    );
  }
  return (
    <div className="w-full">
      <div
        className="flex justify-between items-center px-4 py-6 gap-2 rounded-[24px]"
        style={gradientStyle}
      >
        {/* {viewData.map((el, index) => (
          <ViewCard
            key={index}
            Icon={icons[el.icon]}
            title={el.title}
            value={el.value}
          />
        ))} */}
        {viewData
          .filter((el) => el.icon !== "FiAward")
          .map((el, index) => (
            <ViewCard
              key={index}
              Icon={icons[el.icon]}
              title={el.title}
              value={el.value}
            />
          ))}
      </div>
    </div>
  );
}

export default OverviewWidget;